export default __webpack_public_path__ + "static/media/aave-logo.7f0cfd97.svg";